import * as React from 'react';
import { AUTH_EXPIRED_EVENT, AUTH_RESET_EVENT, isSessionExpired } from '@/lib/api';

export function useSessionExpired(): boolean {
  const [expired, setExpired] = React.useState(isSessionExpired);
  React.useEffect(() => {
    const expire = () => setExpired(true);
    const reset = () => setExpired(false);
    window.addEventListener(AUTH_EXPIRED_EVENT, expire);
    window.addEventListener(AUTH_RESET_EVENT, reset);
    // Catch a 401 returned between render and subscription.
    if (isSessionExpired()) setExpired(true);
    return () => {
      window.removeEventListener(AUTH_EXPIRED_EVENT, expire);
      window.removeEventListener(AUTH_RESET_EVENT, reset);
    };
  }, []);
  return expired;
}
